export default __webpack_public_path__ + "static/media/footer-card-background-mobile.dbfd00fe.svg";